<template>
  <With_Header_Modal_Template title="Новое бронирование">
    <div class="booking">
      <div class="booking_content">
        <custom-select width="100%" maxWidth="100%" mb="15px">
          <option>Beauty Coworking #1</option>
        </custom-select>
        <custom-select width="100%" maxWidth="100%" mb="15px">
          <option>Beauty Coworking #1</option>
        </custom-select>
        <custom-input type="date" mb="15px"/>
        <div class="time_picker">
          <custom-input type="time"/>
          <span class="line_between">—</span>
          <custom-input type="time"/>
        </div>
      </div>
      <div class="booking_footer">
        <ButtonComponent width="100%" variant="filled">Перейти к выбору места</ButtonComponent>
      </div>
    </div>
  </With_Header_Modal_Template>
</template>

<script>
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import ButtonComponent from '@/components/ui/buttons/button-component'
import CustomSelect from '@/components/ui/inputs/custom-select'
import CustomInput from '@/components/ui/inputs/custom-input'

export default {
name: "NewBooking",
  components: {CustomInput, CustomSelect, ButtonComponent, With_Header_Modal_Template}
}
</script>

<style scoped lang="scss">
.booking {
  padding: 20px 15px;
  &_content {
    height: calc(100vh - 170px);
    overflow: auto;
    margin-bottom: 20px;
  }
}
.time_picker {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  .line_between {
    margin: 0 7px;
  }
}

</style>
